import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NewsletterSection.css';
import EmailForm from './EmailForm';
import SocialButtons from './SocialButtons';

const NewsletterSection = () => {
  const [selectedSettings, setSelectedSettings] = useState({
    crypto: { frequency: "7x" }
  });

  const handleError = (errorMessage) => {
    alert(errorMessage);
  };

  const handleCardClick = (cardKey) => {
    setSelectedSettings(prev => {
      const newSettings = { ...prev };
      if (newSettings[cardKey]) {
        // Remove the setting if it exists
        delete newSettings[cardKey];
      } else {
        // Add the setting with the card's defined frequency
        const card = contentCards.find(c => c.key === cardKey);
        newSettings[cardKey] = { frequency: card.frequency };
      }
      return newSettings;
    });
  };

  const contentCards = [
    {
      id: 1,
      key: 'crypto',
      title: "The Crypto Brief",
      frequency: "7x",
      displayFrequency: "7 per week",
      description: "Get smart insights in 3min.",
      selected: !!selectedSettings.crypto
    },
    {
      id: 2,
      key: 'derivatives',
      title: "The Derivatives Outlook",
      frequency: "7x",
      displayFrequency: "7 per week",
      description: "The frontier for futures and options market.",
      selected: !!selectedSettings.derivatives
    },
    {
      id: 3,
      key: 'traditional',
      title: "The Macro Report",
      frequency: "5x",
      displayFrequency: "5 per week",
      description: "Navigate the global market with confidence.",
      selected: !!selectedSettings.traditional,
      isNew: true
    }
  ];

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        {/* Left Side - Image */}
        <div className="newsletter-image-container">
          <img 
            src="/assets/old/home_bottom.png" 
            alt="Historical trading floor" 
            className="newsletter-image"
          />
        </div>

        {/* Right Side - Content */}
        <div className="newsletter-content">
          <div className="newsletter-text">
            <h2 className="newsletter-title">Invest & Trade With Data</h2>
            <p className="newsletter-description">
              Get Tailored Insights on What Matters to You. Everyday of the Week. Whenever you want. 
            </p>
            
            <div className="newsletter-checklist">
              <div className="checklist-item">
                <span className="checkmark">✓</span>
                <span>Full control over your information pipeline.</span>
              </div>
              <div className="checklist-item">
                <span className="checkmark">✓</span>
                <span>Make sharper and faster decisions with insights personalized your way.</span>
              </div>
              <div className="checklist-item">
                <span className="checkmark">✓</span>
                <span>Daily reports to keep you informated on narratives, trends and markets.</span>
              </div>
            </div>

            <p className="newsletter-description">
              Access All Market Insights Your Way. 
            </p>

            <Link to="/account" className="newsletter-cta-button">
              Go Pro
            </Link>
          </div>
        </div>
      </div>

      {/* Newsletter Signup Section - Below the main content */}
      <div className="newsletter-signup-section">
        <div className="newsletter-signup-container">
          <div className="newsletter-signup">
            <div className="newsletter-signup-header">
              <span className="newsletter-signup-label">Newsletter</span>
              <h3 className="newsletter-signup-title">Understanding Any Market Made Easy</h3>
              <p className="newsletter-signup-subtitle">Level up your market insights in 3 minutes a day.</p>
            </div>
            
            <div className="newsletter-form-container">
              <EmailForm 
                placeholder="you@example.com"
                buttonText="Join Free"
                onError={handleError}
                settings={selectedSettings}
              />
            <div className="newsletter-social-buttons-container">
            <SocialButtons />
              </div>
            </div>
          </div>

          <div className="content-cards">
            {contentCards.map((card) => (
              <div 
                key={card.id} 
                className={`content-card ${card.selected ? 'selected' : ''}`}
                onClick={() => handleCardClick(card.key)}
              >
                {card.isNew && <span className="new-badge">New</span>}
                <div className="card-frequency">{card.displayFrequency}</div>
                <h4 className="card-title">{card.title}</h4>
                <p className="card-description">{card.description}</p>
                <div className="card-selection">
                  <span className="selection-indicator">
                    {card.selected ? 'Selected' : 'Click to select'}
                  </span>
                  <div className={`selection-dot ${card.selected ? 'active' : ''}`}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default NewsletterSection;
